
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("c6z2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// ====================================================================================
// formHeaderSearch.module
// ====================================================================================
var $8d013a74beff93b3$var$headerSearch = document.querySelector(".header .form-header-search");
var $8d013a74beff93b3$var$searchInput = $8d013a74beff93b3$var$headerSearch.querySelector("input");
var $8d013a74beff93b3$var$changeFormClasses = function changeFormClasses(func) {
    var formClasses = $8d013a74beff93b3$var$headerSearch.classList;
    if (func === "add") {
        formClasses.add("active");
        return;
    }
    if (func === "remove") {
        formClasses.remove("active");
        return;
    }
    if (formClasses.contains("active")) formClasses.remove("active");
    else formClasses.add("active");
};
var $8d013a74beff93b3$var$init = module.exports.init = function init() {
    var attempts = 0;
    var prevScreenWidth = window.innerWidth;
    // if document.ready needed
    var _whenComplete = function whenComplete() {
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") {
            // Search handler for mobile screens
            // Search field with submit button are fading up when user clicks on a round search button
            $8d013a74beff93b3$var$headerSearch.querySelector('[data-js="header-search"]').addEventListener("click", function(e) {
                if (prevScreenWidth > 767) return;
                e.preventDefault();
                $8d013a74beff93b3$var$changeFormClasses();
            });
            // Search focusin handler (tablets and desktops)
            // Search field becomes wider on focus event and search button is within search box
            $8d013a74beff93b3$var$searchInput.addEventListener("focusin", function(e) {
                if (prevScreenWidth < 768) return;
                e.preventDefault();
                $8d013a74beff93b3$var$changeFormClasses("add");
            });
            // Mobile search focusout handler (tablets and desktops)
            $8d013a74beff93b3$var$searchInput.addEventListener("focusout", function(e) {
                if (prevScreenWidth < 768) return;
                e.preventDefault();
                $8d013a74beff93b3$var$changeFormClasses("remove");
            });
            window.addEventListener("resize", function(e) {
                if (!e.isTrigger) {
                    clearTimeout(this._timer);
                    this._timer = setTimeout(function() {
                        // google chrome bug fix
                        if (Math.abs(window.innerWidth - prevScreenWidth) < 99) return;
                        prevScreenWidth = window.innerWidth;
                    }, 400);
                }
            });
        } else setTimeout(function() {
            _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=formHeaderSearch.module.dbd797e8.js.map
